<template>
  <div class="editor-2025-container justify-between">
    <EditorHeader
      :saveLoading="saveLoading"
      @clickMyResume="clickMyResume"
      @clickChangeTheme="clickChangeTheme"
      @copyResume="copyResume"
      @clickMergeResume="clickMergeResume"
      @clickRenameResume="clickRenameResume"
      @clickPopupItem="clickPopupItem"
      @clickTranslationResume="clickTranslationResume"
      @clickShareWx="clickShareWx"
      @clickSendEmail="clickSendEmail"
      @clickDelete="deleteResume"
      @clickEditModuleName="clickEditModuleName"
      @clickDeleteModule="clickDeleteModule"
      @editItem="editItem"
      @changeSaveLoading="changeSaveLoading"
    />
    <div class="editor-wrapper">
      <EditorBlockTabs :displayType="displayType" @clickTab="clickTab" />
      <div v-show="displayType === 'editor'" class="editor-container relative">
        <div ref="editorContentRef" class="editor-content" :class="{ collapse: collapse }">
          <ResumeCheckTotal
            :checkResult="checkResult"
            :checkLoading="resumeChecking"
            @clickCheckResume="fetchResumeCheckResult"
            @clickIssueItem="clickIssueItem"
          />
          <EditorProfile
            id="sectionModulebasic_info"
            :issueCount="returnIssueCount('basic_info')"
            :moduleIcon="moduleIcons.basic_info"
            :suggestionsModule="checkResult && checkResult.basic_info_questions"
            :editId="editId"
            @editItem="editItem"
            @refreshCheckResult="fetchLastResumeCheckResult"
            @changeSaveLoading="changeSaveLoading"
          />
          <section
            v-for="(item, index) in cvDetail.submodule_info.sections_position"
            :key="index"
            class="section-item"
          >
            <component
              :id="`sectionModule${item.type === 'custom' ? item.id : item.type}`"
              :ref="`sectionModule${item.type === 'custom' ? item.id : item.type}`"
              :moduleIcon="moduleIcons[item.type]"
              :issueCount="returnIssueCount(item.type)"
              :is="returnSectionComponent(item)"
              :suggestionsModule="returnSuggestionModule(item.id, item.type)"
              :checkResult="checkResult ? checkResult.smart_check_result : {}"
              :editId="editId"
              :moduleId="item.id"
              :moduleType="item.type"
              @editItem="editItem"
              @buyMember="buyMember"
              @refreshCheckResult="fetchLastResumeCheckResult"
              @changeSaveLoading="changeSaveLoading"
            />
          </section>
        </div>
      </div>
      <div v-show="displayType === 'template'" class="resume-format-change">
        <ResumeFormatChange />
      </div>
      <MockInterview v-show="displayType === 'interview'" @buyMember="buyMember" />
      <template v-if="cvDetail && cvDetail.basic_info && cvDetail.basic_info.mentor_id">
        <!-- 导师流程 -->
        <MentorProcess
          v-show="displayType === 'mentorProcess' && !!cvDetail.basic_info.mentor_id"
        />
      </template>
      <!-- ai导师 -->
      <div v-show="displayType === 'aiMentor'" class="ai-mentor-content">
        <AiMentor :cvDetail="cvDetail" :profile="profile" :cvName="cvDetail.basic_info.cv_name" />
      </div>
      <!-- 职位 -->
      <RecommendPosition v-show="displayType === 'jobs'" />
    </div>
    <div class="flex justify-center flex-1">
      <div class="resume-preview-wrapper relative">
        <Resume @get-pages="getPages" />
        <!-- <cvScanner v-if="resumeChecking" /> -->
      </div>
    </div>
    <ExperienceBox />
    <EditorRenameModal
      ref="renameModalRef"
      :cvToken="cvDetail.basic_info.token"
      :cvName="cvDetail.basic_info.cv_name"
      @editCvName="confirmResumeName"
    />
    <PayAlert
      v-if="payAlertVisible"
      :displayContinueBtn="displayContinueBtn"
      :displayCloseBtn="displayCloseBtn"
      :buySuccessCallback="!displayCloseBtn ? updateResumeIntercept : null"
      @close="payAlertVisible = false"
      @downloadContinue="continueCallback"
    />
    <BannerAlert :alertData="alertData" @close="alertData = {}" />
    <ResumeMergeModal
      ref="resumeMergeModalRef"
      :token="cvDetail && cvDetail.basic_info && cvDetail.basic_info.token"
      :cv_name="cvDetail && cvDetail.basic_info && cvDetail.basic_info.cv_name"
      :cv_lang="cvDetail && cvDetail.basic_info && cvDetail.basic_info.lang"
      @handleDownload="handleDownloadResume"
    />
    <ResumeWxShare ref="resumeWxShareRef" />
    <ResumeSendEmail
      ref="resumeSendEmailRef"
      :profile="profile"
      :cvToken="cvDetail.basic_info.token"
      :cvName="cvDetail.basic_info.cv_name"
      @confirmSendEmail="confirmSendEmail"
    />
    <transition name="el-fade-in-linear">
      <NpsModal v-if="npsVisible" :isShow="npsVisible" :token="cvDetail.basic_info.token" />
    </transition>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import api from '@/api';
import EditorRenameModal from './components/EditorRenameModal/EditorRenameModal.vue';
import EditorHeader from './components/EditorHeader/EditorHeader.vue';
import EditorBlockTabs from './components/EditorBlockTabs/EditorBlockTabs.vue';
import ResumeFormatChange from './components/ResumeFormatChange/ResumeFormatChange.vue';
import ResumeCheckTotal from './components/ResumeCheckTotal/ResumeCheckTotal.vue';
import EditorProfile from './components/EditorProfile/EditorProfile.vue';
import Resume from './components/ResumePreview/resume.vue';
import EditorWorkModule from './components/EditorWorkModule/EditorWorkModule.vue';
import EditorEduModule from './components/EditorEduModule/EditorEduModule.vue';
import EditorOrgModule from './components/EditorOrgModule/EditorOrgModule.vue';
import EditorOpuModule from './components/EditorOpuModule/EditorOpuModule.vue';
import EditorExtrasModule from './components/EditorExtrasModule/EditorExtrasModule.vue';
import EditorCustomModule from './components/EditorCustomModule/EditorCustomModule.vue';
import EditorSkillPersonal from './components/EditorSkillPersonal/EditorSkillPersonal.vue';
import EditorHonor from './components/EditorHonor/EditorHonor.vue';
import ExperienceBox from './components/ExperienceBox/ExperienceBox.vue';
import MockInterview from './components/MockInterview/MockInterview.vue';
import MentorProcess from './components/MentorProcess/MentorProcess.vue';
import PayAlert from '@/views/account/user/payAlert.vue';
import BannerAlert from '@/views/cvs/components/alert';
import ResumeMergeModal from './components/ResumeMergeModal/ResumeMergeModal.vue';
import ResumeWxShare from './components/ResumeWxShare/ResumeWxShare.vue';
import ResumeSendEmail from './components/ResumeSendEmail/ResumeSendEmail.vue';
import cvScanner from '@/views/editorResume/cvsEditor/components/resume/cv-scanner.vue';
import RecommendPosition from './components/RecommendPosition/RecommendPosition.vue';
import NpsModal from '@/components/nps';
import { resumeOperationMixin } from './mixins/resume-operation';
import { isSupportFontFamily, get_tUser, debounce } from '@/assets/js/util';

import AiMentor from './components/AiMentor/index.vue';

const moduleIcons = {
  basic_info: 'https://logo.wondercv.com/banners/oSG5pYqaCB8d2cd.png',
  works: 'https://logo.wondercv.com/banners/r1JYVtJ7MxyBr8Q.png',
  edus: 'https://logo.wondercv.com/banners/2AibTbdd4n2JheN.png',
  orgs: 'https://logo.wondercv.com/banners/6ee31SYhHkOr1DW.png',
  extras: 'https://logo.wondercv.com/banners/8HJ1wu2DFlM8rRp.png',
  project_experience: 'https://logo.wondercv.com/banners/XFnZeF9HOMfwsCv.png',
  custom: 'https://logo.wondercv.com/banners/ehbKU0qJdmwahVz.png',
  honor: 'https://logo.wondercv.com/banners/Lrz55fKFGP994cJ.png',
  personal_summary: 'https://logo.wondercv.com/banners/hmlURlJiHpcsxBO.png',
  reasearch_experience: 'https://logo.wondercv.com/banners/ZZDxchcG1EMJTae.png',
  skill_list: 'https://logo.wondercv.com/banners/wiS48x21utQ7ldi.png',
  opus: 'https://logo.wondercv.com/banners/cOkksExMhnWHqSZ.png',
};

export default {
  name: 'Editor2025',
  mixins: [resumeOperationMixin],
  components: {
    EditorHeader,
    EditorProfile,
    Resume,
    EditorWorkModule,
    EditorEduModule,
    EditorOrgModule,
    EditorOpuModule,
    EditorRenameModal,
    EditorCustomModule,
    EditorSkillPersonal,
    EditorHonor,
    EditorExtrasModule,
    ExperienceBox,
    MentorProcess,
    PayAlert,
    BannerAlert,
    ResumeMergeModal,
    ResumeWxShare,
    ResumeSendEmail,
    ResumeCheckTotal,
    EditorBlockTabs,
    ResumeFormatChange,
    RecommendPosition,
    MockInterview,
    AiMentor,
    cvScanner,
    NpsModal,
  },
  data() {
    return {
      editId: '',
      collapse: false,
      displayType: 'editor',
      checkResult: null,
      resumeChecking: false,
      saveLoading: false,
      oldScrollTop: 0,
      npsVisible: false,
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    ...mapState('editor', ['cvDetail', 'profile']),
    ...mapGetters('experience', ['experienceListLength']),
    moduleIcons() {
      return moduleIcons;
    },
  },
  watch: {
    'personInfo.theme': {
      handler(newVal) {
        const root = document.documentElement;
        root.setAttribute('data-theme', newVal === 'dark' ? 'dark' : 'light');
      },
      immediate: true,
    },
    editId(newVal, oldVal) {
      if (newVal && oldVal) {
        this.$nextTick(() => {
          const el = document.getElementById(`experience${newVal}`);
          el?.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
      } else if (newVal || oldVal) {
        this.$nextTick(() => {
          const el = document.getElementById(`experience${newVal || oldVal}`);
          el?.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
      }
    },
  },
  methods: {
    ...mapActions('cv', ['getCvsList']),
    returnIssueCount(type) {
      return this.checkResult?.suggestions?.list?.find((item) => item.type === type)?.count || 0;
    },
    changeSaveLoading(loading) {
      this.saveLoading = loading;
    },
    returnSuggestionModule(id, type) {
      if (!this.checkResult) return {};
      switch (type) {
        case 'works':
        case 'edus':
        case 'orgs':
        case 'opus':
          return this.checkResult?.[`${type}_questions`] || {};
        case 'extras':
          return this.checkResult?.others_questions || {};
        default:
          return (
            this.checkResult?.custom_sections_questions?.[`${id}`]?.questions ||
            this.checkResult?.[`${type}_questions`]?.questions ||
            {}
          );
      }
    },
    clickIssueItem(item) {
      const id = item.type === 'custom' ? item.id : item.type;
      const el = document.getElementById(`sectionModule${id}`);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    clickTab(type) {
      this.displayType = type;
    },
    clickEditModuleName(item) {
      const type = ['works', 'edus'].includes(item.type) ? item.type.slice(0, -1) : '';
      this.$refs[
        `sectionModule${item.type === 'custom' ? item.id : item.type}`
      ]?.[0]?.clickRenameModule?.(type, item.title);
    },
    clickDeleteModule(item) {
      this.$refs[
        `sectionModule${item.type === 'custom' ? item.id : item.type}`
      ]?.[0]?.handleClickRemoveModule?.();
    },
    findNotSaveExperience(id) {
      const { sections_position, custom_sections_titles } = this.cvDetail?.submodule_info || {};

      for (let i = 0; i < sections_position.length; i++) {
        const type =
          sections_position[i].type === 'custom'
            ? `${sections_position[i].id}`
            : sections_position[i].type;

        const list = this.$store.state.editor[type] || [];

        const editExperience = Array.isArray(list) && list?.find((item) => item.id === this.editId);

        const messages = {
          sectionModuleextras: `请先保存${this.cvDetail.submodule_info.extras_title}后重试`,
          sectionModulebasic_info: '请先保存基本信息后重试',
        };

        if (editExperience) {
          const title = sections_position[i].id
            ? custom_sections_titles[`${sections_position[i].id}_title`]
            : this.cvDetail.submodule_info[`${type}_title`];
          const { name, university, company } = editExperience;

          const infoTitle = university || company || name || editExperience.title || '';

          const message = `请先保存${title}${infoTitle ? `-${infoTitle}` : ''}后再重试`;

          return this.$message.error(message);
        } else if (messages[id]) {
          return this.$message.error(messages[id]);
        }
      }
    },
    scrollToEditExperience() {
      const id =
        this.editId === 'extras-edit'
          ? 'sectionModuleextras'
          : this.editId === 'profile'
          ? 'sectionModulebasic_info'
          : `experience${this.editId}`;
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.findNotSaveExperience(id);
    },
    clickMyResume() {
      if (this.editId) {
        this.scrollToEditExperience();
      } else {
        window.location.replace('/cvs');
      }
    },
    clickChangeTheme: debounce(async function () {
      try {
        const { c_t } = await get_tUser();
        const theme = this.personInfo.theme === 'dark' ? 'light' : 'dark';
        const res = await api.cvsEditor.changeEditorTheme(c_t, {
          theme,
        });
        if (res.code === 1000) {
          this.$store.dispatch('me/setUserPersonInfo', {
            ...this.personInfo,
            theme,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }, 200),
    calcResumeWidth() {
      const MAX_WIDTH = 720;
      const MIN_WIDTH = 570;
      const bodyWidth = document.body.offsetWidth;
      // 666 是编辑器宽度，22 是编辑器和简历之间的间距
      const surplus = bodyWidth - 666 - 22;
      const resumeWidth = Math.min(Math.max(surplus, MIN_WIDTH), MAX_WIDTH);
      this.$store.commit('editor/setResumeWidthByValue', resumeWidth);
    },
    returnSectionComponent(item) {
      if (item.type) {
        switch (item.type) {
          case 'works':
            return EditorWorkModule;
          case 'edus':
            return EditorEduModule;
          case 'orgs':
            return EditorOrgModule;
          case 'opus':
            return EditorOpuModule;
          case 'extras':
            return EditorExtrasModule;
          case 'skill_list':
          case 'personal_summary':
            return EditorSkillPersonal;
          case 'honor':
            return EditorHonor;
          default:
            return EditorCustomModule;
        }
      } else {
        return null;
      }
    },
    editItem(id, sameInfo) {
      this.editId = this.editId === id && sameInfo ? '' : id;
      this.collapse = !!this.editId;
      if (this.editId) {
        const timer = setTimeout(() => {
          this.collapse = false;
          clearTimeout(timer);
        }, 500);
      } else {
        this.collapse = false;
      }
    },
    buyMember() {
      this.displayContinueBtn = false;
      this.displayCloseBtn = true;
      this.payAlertVisible = true;
    },
    async fetchResumeCheckResult() {
      if (this.resumeChecking) return;
      this.resumeChecking = true;
      this.editItem(this.editId, true);
      try {
        const custom_sections = [];
        const {
          submodule_info: { sections_position },
          basic_info: { token },
        } = this.cvDetail;
        const payload = {
          cv_token: token,
          cv: {
            ...this.cvDetail,
            profile: this.$store.state.editor.profile,
          },
          manual: '1',
          active: '1',
        };

        const ignoreModules = ['honor', 'opus'];

        sections_position.forEach((item) => {
          if (item.id && !ignoreModules.includes(item.type)) {
            const module = {
              id: item.id,
              infos: this.$store.state.editor[item.type] || this.$store.state.editor[item.id] || [],
              section: item.type,
            };
            custom_sections.push(module);
          } else if (!ignoreModules.includes(item.type)) {
            payload.cv[item.type] = this.$store.state.editor[item.type];
          }
        });

        payload.cv.custom_sections = custom_sections;

        const res = await api.cvsEditor.getResumeCheckResult(payload);
        if (res.code === 1000) {
          this.checkResult = res.data;
        } else if (res.code === 600213 || res.code === 2030) {
          this.$message.error(res.message);
          this.payAlertVisible = true;
          this.displayContinueBtn = false;
          this.displayCloseBtn = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.resumeChecking = false;
      }
    },
    async fetchLastResumeCheckResult() {
      try {
        const res = await api.cvsEditor.getLastResumeCheckResult({
          cv_token: this.$route.params.token,
        });
        if (res.code === 1000) {
          this.checkResult = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    //检测当前系统是否包含字体
    _checkFontFamily() {
      let userFontFamily = JSON.parse(JSON.stringify(this.$store.state.experience.userFontFamily));
      let { lang } = this.cvDetail.basic_info;
      let vipFont = [
        '黑体',
        '楷体',
        '仿宋',
        '宋体',
        'Helvetica',
        'Times New Roman',
        'Droid Serif',
        'Source Code Pro',
      ];
      userFontFamily[lang].forEach((sitem) => {
        let hasFont = false;
        if (vipFont.includes(sitem.cnName)) {
          sitem.isVip = true;
        }
        sitem.name.forEach((font) => {
          if (isSupportFontFamily(font)) {
            hasFont = true;
          }
        });
        sitem.hasFont = hasFont;
      });
      this.$store.commit('experience/initUserFontFamily', userFontFamily);
    },
    async initResumeData() {
      try {
        this.fetchLastResumeCheckResult();
        const res = await this.$store.dispatch('editor/getCvDetail', this.$route.params.token);
        if (res.code === 1000) {
          await this.$store.dispatch('editor/getCvInfoData', {
            check: false,
            only_desc: false,
          });
          if (!this.profile?.id) {
            this.editId = 'profile';
          }
        } else if (res.code === 80120) {
          this.$router.replace('/cvs');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchExperienceData() {
      try {
        await this.$store.dispatch('experience/getExperienceList', this.cvDetail);
      } catch (error) {
        console.log(error);
      }
    },
    async initNpsVisible() {
      try {
        const { c_t } = await get_tUser();
        const res = await api.nps.showNps({ id: c_t, channel: 6 });
        if (res.code === 1000) {
          this.npsVisible = this.experienceListLength > 3 && res.data.is_fill;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateResumeIntercept() {
      return await api.cvsEditor.updateTranslateResumeInfo({
        cv_token: this.$route.params.token,
      });
    },
    async checkTranslationResume() {
      try {
        if (!this.cvDetail.basic_info.trans_intercept) return;
        const res = await this.updateResumeIntercept();
        if (res.code === 1000 && !res.data.trans_intercept) {
          this.$store.commit('editor/setCvDetail', {
            ...this.cvDetail,
            basic_info: {
              ...this.cvDetail.basic_info,
              trans_intercept: false,
            },
          });
        } else if (res.code === 1000) {
          this.payAlertVisible = true;
          this.displayContinueBtn = false;
          this.displayCloseBtn = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.calcResumeWidth();
    await this.initResumeData();
    this._checkFontFamily();
    this.checkTranslationResume();
    this.$store.dispatch('cvs/getCvSectionTitle');
    this.$nextTick(() => {});
    //获取cvs列表
    this.getCvsList();
    await this.fetchExperienceData();
    this.initNpsVisible();
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.editor-2025-container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 100vh;
  box-sizing: border-box;
  background-color: $page-bg-color;
  padding-top: 50px;
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease,
    background 0.3s ease;
  .editor-wrapper {
    display: flex;
    width: 666px;
    // flex: 1;
    padding-top: 24px;
    box-sizing: border-box;
    flex-shrink: 0;
    background-color: $page-bg-sub-color;
    .editor-container {
      flex: 1;
      background-color: $page-bg-sub-color;
      box-sizing: border-box;
      padding-right: 24px;
      padding-top: 158px;
    }
    .editor-content {
      width: 526px;
      box-sizing: border-box;
      margin-left: 24px;
      max-height: 100%;
      overflow-y: scroll;
      transition: padding-bottom 0.3s ease-in;
      &::-webkit-scrollbar {
        display: none;
      }
      // &.collapse {
      //   padding-bottom: 660px;
      // }
      .section-item:last-child {
        margin-bottom: 660px;
      }
    }
    .ai-mentor-content {
      // width: 526px;
      box-sizing: border-box;
      max-height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .resume-preview-wrapper {
    flex: 1;
    min-width: 540px;
    max-width: 720px;
    max-height: 100%;
    overflow: hidden;
    margin-left: 22px;
    padding-top: 24px;
    overflow-y: scroll;
    padding-bottom: 24px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  * {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease,
      background 0.3s ease;
  }
}
</style>
